import https from "./https";
import store from "@/store";

const partnerMarketingPlan = {
  getPartnerMarketingPlans(params) {
    const organization = store.state.general.organization;
    return https.get(`admin/organizations/${organization.id}/partner-marketing-plans`, { params });
  },
  getPartnerMarketingPlansByEvent(eventId, params) {
    const organization = store.state.general.organization;
    return https.get(`admin/organizations/${organization.id}/partner-marketing-events/${eventId}/partner-marketing-plans`, { params });
  },
  getPartnerMarketingPlan(id) {
    const organization = store.state.general.organization;
    return https.get(`admin/organizations/${organization.id}/partner-marketing-plans/${id}`);
  },
  createPartnerMarketingPlan(params) {
    const organization = store.state.general.organization;
    return https.post(`admin/organizations/${organization.id}/partner-marketing-plans`, params);
  },
  createPartnerMarketingPlanForEvent(eventId, params) {
    const organization = store.state.general.organization;
    return https.post(`admin/organizations/${organization.id}/partner-marketing-events/${eventId}/partner-marketing-plans`, params);
  },
  updatePartnerMarketingPlan(id, params) {
    const organization = store.state.general.organization;
    return https.put(`admin/organizations/${organization.id}/partner-marketing-plans/${id}`, params);
  },
  checkCodes(id) {
    const organization = store.state.general.organization;
    return https.get(`admin/organizations/${organization.id}/partner-marketing-plans/${id}/check-codes`);
  },
  deletePartnerMarketingPlan(id) {
    const organization = store.state.general.organization;
    return https.delete(`admin/organizations/${organization.id}/partner-marketing-plans/${id}`);
  },
  uploadImageByBase64(data) {
    const organization = store.state.general.organization;
    return https.post(`admin/organizations/${organization.id}/partner-marketing-plans/images/upload-by-base64`, data);
  },
  removeImageUrl(id) {
    const organization = store.state.general.organization;
    return https.delete(`admin/organizations/${organization.id}/partner-marketing-plans/${id}/remove-image-url`);
  },
  getMaxSort(eventId) {
    const organization = store.state.general.organization;
    return https.get(`admin/organizations/${organization.id}/partner-marketing-plans/max-sort`, {
      params: { partner_marketing_event_id: eventId }
    });
  },
  getPartnerNames() {
    const organization = store.state.general.organization;
    return https.get(`admin/organizations/${organization.id}/partner-marketing-plans/partner-names`);
  }
};

export default partnerMarketingPlan;